import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { CasesGenerallCallInfo } from '../../../../../../shared/types/modules/cases-general';
import { CasesGeneralProps } from './props';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../../services/param.service';
import { asyncGetProducts } from '../../../../../../services/product.service';

export const useCasesGeneralCallInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: CasesGeneralProps) => {
    const [channels, setChannels] = useState<ISelect[]>([]);
    const [branch, setBranch] = useState<ISelect[]>([]);
    const [product, setProduct] = useState<ISelect[]>([]);
    const [officie, setOffice] = useState<ISelect[]>([]);

    const onSubmit = (data: CasesGenerallCallInfo) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('callId', data?.callId || '');
        formik?.setFieldValue('channel', data?.channel || '');
        formik?.setFieldValue('policie', data?.policie || '');
        formik?.setFieldValue('officie', data?.officie || '');
        formik?.setFieldValue('branch', data?.branch || '');
        formik?.setFieldValue('product', data?.product || '');
        formik?.setFieldValue('plate', data?.plate || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.CASES_GENERAL_INFORMATION_CHANNEL).then(
            (params) => setChannels(params)
        );
        asyncGetParams(ParamEnum.PQR_REDIRECTION_AREA).then((params) =>
            setBranch(params)
        );
        asyncGetProducts({ applyPqr: true, applyEscalations: false }).then(
            (product) => setProduct(product)
        );

        asyncGetParams(ParamEnum.PQR_BRANCH).then((officie) =>
            setOffice(officie)
        );
    }, []);

    return {
        formik,
        channels,
        branch,
        product,
        officie,
    };
};
